import { Transactions } from "./transaction";
import { RawTransactions } from "./transaction.types";

export const mockRawTransactions = (): RawTransactions => {
  return {
    totalResult: 5,
    projections: [
      {
        accountingDate: "2025-03-20T03:00:00",
        actualId: "20250320030000_969696969696_SHIPOUT",
        centerCode: "9696",
        centerId: "124ca01b-d356-370a-ad4f-38982a5127c4",
        channel: "",
        collectionId: "",
        countryId: "ES",
        delegation: "028",
        deviceDetails: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          deviceName: "RRQAPunto_09",
          deviceCode: "969696969696",
          deviceManufacturer: "RRQAPunto_09",
          deviceModel: "RRQAPunto_09",
          deviceType: "Aceptadora",
          deviceIp: "1.1.1.1",
          devicePort: 8080,
          solutionType: "RRQAPunto_09",
          maxNoteCapacity: 200,
          maxCoinCapacity: 200,
          countryCode: "ES",
          currencies: ["EUR", "USD"],
          delegationCode: "028",
        },
        deviceId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        entity: {
          id: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
          name: "RRQAPunto_09",
          code: "969696",
          countryCode: "ES",
          imageLink:
            "https://emazgenkindstg03.z6.web.core.windows.net/img/entity/c28dee41-f883-3407-bd48-0ccb3bb5f719.png",
        },
        entityId: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
        id: "41b99ed2-f5a5-4c12-bee3-eb6468700b31",
        logicCashTodayId: "",
        origin: "COINACCEPTOR",
        receiptNumber: "52399",
        servicePoint: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          isEarlyValue: false,
          name: "RRQAPunto_09",
          centerCode: "9696",
          centerName: "RRQAPunto_09",
        },
        servicePointCode: "96",
        servicePointId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        strapSealCode: "",
        systemEntryDate: "",
        teller: "96969696969610011223",
        tellerLogin: "599617",
        tellerName: "QA Team",
        timeZone: "GMT+02:00",
        transactionDate: "2025-03-20T05:00:00",
        transactionInfo: "",
        transactionRef: "",
        transactionType: "SHIPOUT",
        hasAccreditation: false,
        hasNotification: false,
        amounts: [
          {
            currency: "EUR",
            category: "CAT_4",
            total: 1.3e2,
            numItems: 25,
            barCodes: [],
          },
        ],
        denominations: [
          {
            boxName: "COINACCEPTOR",
            barCode: "",
            cardNumber: "",
            category: "CAT_4",
            codeLine: "",
            collectionId: "",
            currency: "EUR",
            date: "",
            value: 500,
            description: "",
            numItems: 24,
            subType: "",
            total: 12000,
            type: "NOTE",
            boxNameRaw: "COINACCEPTOR",
          },
          {
            boxName: "COINACCEPTOR",
            barCode: "",
            cardNumber: "",
            category: "CAT_4",
            codeLine: "",
            collectionId: "",
            currency: "EUR",
            date: "",
            value: 1000,
            description: "",
            numItems: 1,
            subType: "",
            total: 1000,
            type: "NOTE",
            boxNameRaw: "COINACCEPTOR",
          },
        ],
        extraDatas: [],
        amountDetails: [
          {
            currency: "EUR",
            category: "CAT_4",
            total: 13000,
            barCodes: [],
            accreditation: undefined,
            notification: undefined,
          },
        ],
        currencies: [
          {
            exponent: -2,
            iso: "EUR",
          },
        ],
      },
      {
        accountingDate: "2025-03-20T08:00:00",
        actualId: "20250320080000_969696969696_CASHIN",
        centerCode: "9696",
        centerId: "124ca01b-d356-370a-ad4f-38982a5127c4",
        channel: "",
        collectionId: "",
        countryId: "ES",
        delegation: "028",
        deviceDetails: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          deviceName: "RRQAPunto_09",
          deviceCode: "969696969696",
          deviceManufacturer: "RRQAPunto_09",
          deviceModel: "RRQAPunto_09",
          deviceType: "Aceptadora",
          deviceIp: "1.1.1.1",
          devicePort: 9090,
          solutionType: "RRQAPunto_09",
          maxNoteCapacity: 200,
          maxCoinCapacity: 200,
          countryCode: "ES",
          currencies: ["EUR", "USD"],
          delegationCode: "028",
        },
        deviceId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        entity: {
          id: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
          name: "RRQAPunto_09",
          code: "969696",
          countryCode: "ES",
          imageLink:
            "https://emazgenkindstg03.z6.web.core.windows.net/img/entity/c28dee41-f883-3407-bd48-0ccb3bb5f719.png",
        },
        entityId: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
        id: "1e6558b4-5201-429c-a4fa-31785bf1db14",
        logicCashTodayId: "",
        origin: "NOTEACCEPTOR",
        receiptNumber: "52399",
        servicePoint: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          isEarlyValue: false,
          name: "RRQAPunto_09",
          centerCode: "9696",
          centerName: "RRQAPunto_09",
        },
        servicePointCode: "96",
        servicePointId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        strapSealCode: "",
        systemEntryDate: "",
        teller: "96969696969610011223",
        tellerLogin: "599617",
        tellerName: "QA Team",
        timeZone: "GMT+02:00",
        transactionDate: "2025-03-20T08:00:00",
        transactionInfo: "",
        transactionRef: "",
        transactionType: "CASHIN",
        hasAccreditation: false,
        hasNotification: false,
        amounts: [
          {
            currency: "EUR",
            category: "CAT_4",
            total: 1.3e2,
            numItems: 25,
            barCodes: [],
          },
        ],
        denominations: [
          {
            boxName: "NOTEACCEPTOR",
            barCode: "",
            cardNumber: "",
            category: "CAT_4",
            codeLine: "",
            collectionId: "",
            currency: "EUR",
            date: "",
            value: 500,
            description: "",
            numItems: 24,
            subType: "",
            total: 12000,
            type: "NOTE",
            boxNameRaw: "NOTEACCEPTOR",
          },
          {
            boxName: "NOTEACCEPTOR",
            barCode: "",
            cardNumber: "",
            category: "CAT_4",
            codeLine: "",
            collectionId: "",
            currency: "EUR",
            date: "",
            value: 1000,
            description: "",
            numItems: 1,
            subType: "",
            total: 1000,
            type: "NOTE",
            boxNameRaw: "NOTEACCEPTOR",
          },
        ],
        extraDatas: [],
        amountDetails: [
          {
            currency: "EUR",
            category: "CAT_4",
            total: 13000,
            barCodes: [],
            accreditation: undefined,
            notification: undefined,
          },
        ],
        currencies: [
          {
            exponent: -2,
            iso: "EUR",
          },
        ],
      },
      {
        accountingDate: "2025-03-20T08:05:00",
        actualId: "20250320080500_969696969696_CASHIN",
        centerCode: "9696",
        centerId: "124ca01b-d356-370a-ad4f-38982a5127c4",
        channel: "",
        collectionId: "D20240619095300",
        countryId: "ES",
        delegation: "028",
        deviceDetails: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          deviceName: "RRQAPunto_09",
          deviceCode: "969696969696",
          deviceManufacturer: "RRQAPunto_09",
          deviceModel: "RRQAPunto_09",
          deviceType: "Aceptadora",
          deviceIp: "1.1.1.1",
          devicePort: 8080,
          solutionType: "RRQAPunto_09",
          maxNoteCapacity: 200,
          maxCoinCapacity: 200,
          countryCode: "ES",
          currencies: ["EUR", "USD"],
          delegationCode: "028",
        },
        deviceId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        entity: {
          id: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
          name: "RRQAPunto_09",
          code: "969696",
          countryCode: "ES",
          imageLink:
            "https://emazgenkindstg03.z6.web.core.windows.net/img/entity/c28dee41-f883-3407-bd48-0ccb3bb5f719.png",
        },
        entityId: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
        id: "d7200a09-6219-40d4-876b-86de239a0088",
        logicCashTodayId: "",
        origin: "COINRECYCLER",
        receiptNumber: "52399",
        servicePoint: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          isEarlyValue: false,
          name: "RRQAPunto_09",
          centerCode: "9696",
          centerName: "RRQAPunto_09",
        },
        servicePointCode: "96",
        servicePointId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        strapSealCode: "",
        systemEntryDate: "",
        teller: "96969696969610011223",
        tellerLogin: "599617",
        tellerName: "QA Team",
        timeZone: "GMT+02:00",
        transactionDate: "2025-03-20T08:05:00",
        transactionInfo: "",
        transactionRef: "",
        transactionType: "CASHIN",
        hasAccreditation: false,
        hasNotification: false,
        amounts: [
          {
            currency: "USD",
            category: "",
            total: 3.5e3,
            numItems: 65,
            barCodes: ["CA5865678"],
          },
        ],
        denominations: [
          {
            boxName: "COINRECYCLER",
            barCode: "CA5865678",
            cardNumber: "",
            category: "",
            codeLine: "",
            collectionId: "",
            currency: "USD",
            date: "",
            value: 0,
            description: "",
            numItems: 65,
            subType: "",
            total: 350000,
            type: "AGGR",
            boxNameRaw: "COINRECYCLER",
          },
        ],
        extraDatas: [],
        amountDetails: [
          {
            currency: "USD",
            category: "",
            total: 350000,
            barCodes: ["CA5865678"],
            accreditation: undefined,
            notification: undefined,
          },
        ],
        currencies: [
          {
            exponent: -2,
            iso: "USD",
          },
        ],
      },
      {
        accountingDate: "2025-03-20T08:45:00",
        actualId: "20250320084500_969696969696_CASHIN",
        centerCode: "9696",
        centerId: "124ca01b-d356-370a-ad4f-38982a5127c4",
        channel: "",
        collectionId: "",
        countryId: "ES",
        delegation: "028",
        deviceDetails: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          deviceName: "RRQAPunto_09",
          deviceCode: "969696969696",
          deviceManufacturer: "RRQAPunto_09",
          deviceModel: "RRQAPunto_09",
          deviceType: "Aceptadora",
          deviceIp: "1.1.1.1",
          devicePort: 8080,
          solutionType: "RRQAPunto_09",
          maxNoteCapacity: 200,
          maxCoinCapacity: 200,
          countryCode: "ES",
          currencies: ["EUR", "USD"],
          delegationCode: "028",
        },
        deviceId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        entity: {
          id: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
          name: "RRQAPunto_09",
          code: "969696",
          countryCode: "ES",
          imageLink:
            "https://emazgenkindstg03.z6.web.core.windows.net/img/entity/c28dee41-f883-3407-bd48-0ccb3bb5f719.png",
        },
        entityId: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
        id: "83e10bd3-2299-4be2-85f5-19c981624bb9",
        logicCashTodayId: "",
        origin: "NOTERECYCLER",
        receiptNumber: "52399",
        servicePoint: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          isEarlyValue: false,
          name: "RRQAPunto_09",
          centerCode: "9696",
          centerName: "RRQAPunto_09",
        },
        servicePointCode: "96",
        servicePointId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        strapSealCode: "",
        systemEntryDate: "",
        teller: "96969696969610011223",
        tellerLogin: "599617",
        tellerName: "QA Team",
        timeZone: "GMT+02:00",
        transactionDate: "2025-03-20T08:45:00",
        transactionInfo: "",
        transactionRef: "",
        transactionType: "CASHIN",
        hasAccreditation: false,
        hasNotification: false,
        amounts: [
          {
            currency: "EUR",
            category: "CAT_4",
            total: 1.3e2,
            numItems: 25,
            barCodes: [],
          },
        ],
        denominations: [
          {
            boxName: "NOTERECYCLER",
            barCode: "",
            cardNumber: "",
            category: "CAT_4",
            codeLine: "",
            collectionId: "",
            currency: "EUR",
            date: "",
            value: 500,
            description: "",
            numItems: 24,
            subType: "",
            total: 12000,
            type: "NOTE",
            boxNameRaw: "NOTERECYCLER",
          },
          {
            boxName: "NOTERECYCLER",
            barCode: "",
            cardNumber: "",
            category: "CAT_4",
            codeLine: "",
            collectionId: "",
            currency: "EUR",
            date: "",
            value: 1000,
            description: "",
            numItems: 1,
            subType: "",
            total: 1000,
            type: "NOTE",
            boxNameRaw: "NOTERECYCLER",
          },
        ],
        extraDatas: [],
        amountDetails: [
          {
            currency: "EUR",
            category: "CAT_4",
            total: 13000,
            barCodes: [],
            accreditation: undefined,
            notification: undefined,
          },
        ],
        currencies: [
          {
            exponent: -2,
            iso: "EUR",
          },
        ],
      },
      {
        accountingDate: "2025-03-20T08:50:00",
        actualId: "20250320085000_969696969696_SHIPOUT",
        centerCode: "9696",
        centerId: "124ca01b-d356-370a-ad4f-38982a5127c4",
        channel: "",
        collectionId: "",
        countryId: "ES",
        delegation: "028",
        deviceDetails: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          deviceName: "RRQAPunto_09",
          deviceCode: "969696969696",
          deviceManufacturer: "RRQAPunto_09",
          deviceModel: "RRQAPunto_09",
          deviceType: "Aceptadora",
          deviceIp: "1.1.1.1",
          devicePort: 8080,
          solutionType: "RRQAPunto_09",
          maxNoteCapacity: 200,
          maxCoinCapacity: 200,
          countryCode: "ES",
          currencies: ["EUR", "USD"],
          delegationCode: "028",
        },
        deviceId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        entity: {
          id: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
          name: "RRQAPunto_09",
          code: "969696",
          countryCode: "ES",
          imageLink:
            "https://emazgenkindstg03.z6.web.core.windows.net/img/entity/c28dee41-f883-3407-bd48-0ccb3bb5f719.png",
        },
        entityId: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
        id: "61b300c7-8748-48ad-be82-a3141ee546e3",
        logicCashTodayId: "",
        origin: "COINDISPENSER",
        receiptNumber: "52399",
        servicePoint: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          isEarlyValue: false,
          name: "RRQAPunto_09",
          centerCode: "9696",
          centerName: "RRQAPunto_09",
        },
        servicePointCode: "96",
        servicePointId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        strapSealCode: "",
        systemEntryDate: "",
        teller: "96969696969610011223",
        tellerLogin: "599617",
        tellerName: "QA Team",
        timeZone: "GMT+02:00",
        transactionDate: "2025-03-20T08:50:00",
        transactionInfo: "",
        transactionRef: "",
        transactionType: "SHIPOUT",
        hasAccreditation: false,
        hasNotification: false,
        amounts: [
          {
            currency: "EUR",
            category: "CAT_4",
            total: 2.6e2,
            numItems: 50,
            barCodes: [],
          },
        ],
        denominations: [
          {
            boxName: "COINDISPENSER",
            barCode: "",
            cardNumber: "",
            category: "CAT_4",
            codeLine: "",
            collectionId: "",
            currency: "EUR",
            date: "",
            value: 500,
            description: "",
            numItems: 48,
            subType: "",
            total: 24000,
            type: "NOTE",
            boxNameRaw: "COINDISPENSER",
          },
          {
            boxName: "COINDISPENSER",
            barCode: "",
            cardNumber: "",
            category: "CAT_4",
            codeLine: "",
            collectionId: "",
            currency: "EUR",
            date: "",
            value: 1000,
            description: "",
            numItems: 2,
            subType: "",
            total: 2000,
            type: "NOTE",
            boxNameRaw: "COINDISPENSER",
          },
        ],
        extraDatas: [],
        amountDetails: [
          {
            currency: "EUR",
            category: "CAT_4",
            total: 26000,
            barCodes: [],
            accreditation: undefined,
            notification: undefined,
          },
        ],
        currencies: [
          {
            exponent: -2,
            iso: "EUR",
          },
          {
            exponent: -2,
            iso: "USD",
          },
        ],
      },
    ],
  };
};

export const mockTransactions = (data: RawTransactions = mockRawTransactions()): Transactions => new Transactions(data);
